import { render, staticRenderFns } from "./QuoteLogisticsCosts.vue?vue&type=template&id=5efa5f8b&scoped=true"
import script from "./QuoteLogisticsCosts.vue?vue&type=script&lang=js"
export * from "./QuoteLogisticsCosts.vue?vue&type=script&lang=js"
import style0 from "./QuoteLogisticsCosts.vue?vue&type=style&index=0&id=5efa5f8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efa5f8b",
  null
  
)

export default component.exports